import { USER_TYPE } from "./userConstants";

export const INVOICE_STATUS = {
  paid: "Paid",
  clientApproved: "ClientApproved",
  postedToEVO: "PostedToEVO"
}

export const INVOICE_CUSTOM_STATUS = {
  due: "Due"
}

export const getTooltipText = (documentType) => {
  switch (documentType) {
    case 'RIC':
      return 'Outgoing Invoice';
    case 'CIV':
      return 'Incoming Invoice';
    case 'OCNC':
      return 'Outgoing Credit Note To Customer';
    case 'ODNC':
      return 'Outgoing Debit Note To Customer';
    case 'ICNV':
      return 'Incoming Credit Note From Vendor';
    case 'IDNC':
      return 'Incoming Debit Note From Customer';
    default:
      return documentType;
  }
};

export const OPTIONS = { SINGLE: "Single", MULTIPLE: "Multiple"}; 

export const filterInvoices = (invoiceData,checkedStatuses,isInternal) => {
  return invoiceData.filter((invoice) => 
    matchesStatus(invoice, checkedStatuses, isInternal)
  );
};


export const columnConfig = [
  { name: 'invoicedPartyName', flex: 2 },
  { name: 'invoicingPartyName', flex: 2 },
  { name: 'invoiceNumber', flex: 2 },
  { name: 'Invoice Period', flex: 1 },
  { name: 'Amount', flex: 1 },
  { name: 'Invoice Type', flex: 1 },
  { name: 'documentDate', flex: 1.5 },
  { name: 'Invoice Due Date', flex: 2 },
];

export const hasValidFincaTadigCode = (customerMetaInfo) =>customerMetaInfo?.hasOwnProperty('fincaTadigCode') && customerMetaInfo?.fincaTadigCode?.trim() !== '' && customerMetaInfo.fincaTadigCode !== null && customerMetaInfo.fincaTadigCode !== undefined;

export const matchesStatus = (invoice,checkedStatuses,isInternal) => {
  if (checkedStatuses.all) return true;
  if (isInternal) {
    return (
      (checkedStatuses.clientApproved &&
        invoice.status === INVOICE_STATUS.clientApproved) ||
      (checkedStatuses.postedToEvo &&
        invoice.status === INVOICE_STATUS.postedToEVO) ||
      (checkedStatuses.paid &&
        invoice.status === INVOICE_STATUS.paid)
    );
  }
  return (
    (checkedStatuses.due &&
      [
        INVOICE_STATUS.postedToEVO,
        INVOICE_STATUS.clientApproved,
      ].includes(invoice.status)) ||
    (checkedStatuses.paid &&
      invoice.status === INVOICE_STATUS.paid)
  );
};